import React, { useContext, useEffect, useRef } from "react";

import { useNavigate } from "react-router-dom";
import { currency } from "../../utils";

import "./styles.scss";
import { CartContext } from "../../context/cartContext";
import AddButton from "../../components/Icons/AddButton";
import SubButton from "../../components/Icons/SubButton";
import classNames from "classnames";
import { BottomSheet } from "react-spring-bottom-sheet";
import * as OrdersEmpty from "../../assets/lottie/orders-empty.json";
import Lottie from "react-lottie";

function CloseIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="41"
      height="41"
      fill="none"
      viewBox="0 0 41 41"
      {...props}
    >
      <g filter="url(#filter0_d_206_36)">
        <rect
          width="30.556"
          height="30.556"
          x="5.384"
          y="4"
          fill="#fff"
          rx="8"
        ></rect>
      </g>
      <path
        fill="#1C1C1F"
        d="M15.886 12.92l4.776 4.775 4.775-4.775c.398-.398 1.03-.435 1.501-.067l.082.074c.435.435.435 1.14 0 1.575l-4.776 4.776 4.776 4.775c.398.398.435 1.03.067 1.501l-.075.082a1.114 1.114 0 01-1.575 0l-4.775-4.776-4.776 4.776c-.398.398-1.03.435-1.5.067l-.082-.075a1.114 1.114 0 010-1.575l4.775-4.775-4.775-4.776c-.398-.398-.436-1.029-.067-1.5l.074-.082a1.114 1.114 0 011.575 0zm-.778 12.485h-.01.01zm.074-.006l-.025.003a.678.678 0 00.025-.003zm-.165 0l.01.001-.01-.001zm-.07-.015l.008.002-.008-.002zm.305 0l-.03.007a.55.55 0 00.03-.008zm.063-.023l-.023.01a.555.555 0 00.023-.01zm-.498-.033l-.06-.04c.025.02.051.036.078.05l-.018-.01zm.563 0l-.017.01a.664.664 0 00.018-.01zm11.343-.223l-.01.018-.041.06a.54.54 0 00.05-.078zm.03-.069l-.008.021a.612.612 0 00.008-.02zm.022-.07l-.007.027a.457.457 0 00.007-.027zm.01-.066l-.002.023a.575.575 0 00.003-.023zm-.56-11.192l-5.563 5.563-5.563-5.563-.008.007 5.564 5.563-5.564 5.563.008.007 5.563-5.563 5.563 5.563.007-.007-5.563-5.563 5.563-5.563-.007-.007zm.564 11.124v0zm-.006-.074l.003.024a.678.678 0 00-.003-.024zm-.016-.07l.008.03a.507.507 0 00-.008-.03zm-.022-.064l.01.023a.558.558 0 00-.01-.023zm-.033-.065l.01.018a.47.47 0 00-.01-.018zM14.601 13.98l.008.015a.724.724 0 01-.008-.015zm-.032-.07l.008.018-.008-.019zm-.02-.07l.004.02a.476.476 0 01-.005-.02zm-.011-.068l.001.016a.412.412 0 01-.002-.016zm-.003-.072v0zm.006-.066l-.002.01.002-.01zm.015-.07l-.003.008.003-.008zm.055-.13l.04-.06a.548.548 0 00-.05.078l.01-.018zm.751-.216l.019.01.059.04a.548.548 0 00-.078-.05zm10.599 0l-.015.008.015-.008zm-11.126 0l-.015.008.015-.008zm11.653 0l.019.01.059.04a.548.548 0 00-.078-.05zm-11.585-.03l-.017.006a.5.5 0 01.017-.007zm.39-.002l.022.01a.417.417 0 00-.023-.01zm10.738 0l-.019.008a.636.636 0 01.02-.008zm.39.001l.02.008a.54.54 0 00-.02-.008zm-11.447-.021l-.019.004a.655.655 0 01.02-.004zm.248 0l.03.007a.475.475 0 00-.03-.007zm10.88 0l-.02.004a.712.712 0 01.02-.004zm.247 0l.028.007a.548.548 0 00-.028-.007zm-11.307-.011l-.015.001.015-.001zm.113 0l.027.003a.585.585 0 00-.027-.003zm11.014 0l-.016.001a.43.43 0 01.016-.001zm.112 0l.026.003a.657.657 0 00-.026-.003zm-.072-.003h.032-.032zm-11.127 0h.033-.033z"
      ></path>
      <defs>
        <filter
          id="filter0_d_206_36"
          width="40.556"
          height="40.556"
          x="0.384"
          y="0"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="1"></feOffset>
          <feGaussianBlur stdDeviation="2.5"></feGaussianBlur>
          <feComposite in2="hardAlpha" operator="out"></feComposite>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"></feColorMatrix>
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_206_36"
          ></feBlend>
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_206_36"
            result="shape"
          ></feBlend>
        </filter>
      </defs>
    </svg>
  );
}

function CloseGrayIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      fill="none"
      viewBox="0 0 14 14"
      {...props}
    >
      <path
        fill="#DFDEDD"
        d="M1.909.326l4.775 4.776L11.46.326c.398-.398 1.029-.435 1.5-.067l.082.074c.435.435.435 1.14 0 1.576L8.266 6.684l4.776 4.776c.398.398.435 1.029.067 1.5l-.074.082a1.114 1.114 0 01-1.575 0L6.684 8.266 1.91 13.042c-.399.398-1.03.435-1.501.067l-.082-.074a1.114 1.114 0 010-1.575l4.776-4.776L.326 1.91C-.072 1.51-.109.879.26.408L.333.326a1.114 1.114 0 011.576 0zM1.13 12.811h-.009.009zm.074-.006l-.024.003a.517.517 0 00.024-.003zm-.165 0l.01.002-.01-.002zm-.07-.015l.009.003-.009-.003zm.306 0l-.03.007a.638.638 0 00.03-.007zm.063-.022l-.023.009a.549.549 0 00.023-.01zm-.499-.033l-.06-.04c.026.019.052.035.078.05l-.018-.01zm.564 0l-.018.01a.475.475 0 00.018-.01zm11.342-.224l-.01.018-.04.06a.565.565 0 00.05-.078zm.03-.068l-.008.02a.46.46 0 00.009-.02zm.022-.071l-.007.027a.552.552 0 00.007-.027zm.011-.066l-.003.023a.822.822 0 00.003-.023zm-.56-11.192L6.683 6.677 1.121 1.114l-.007.007 5.563 5.563-5.563 5.563.007.007 5.563-5.563 5.563 5.563.007-.007-5.563-5.563 5.563-5.563-.007-.007zm.563 11.124v0zm-.006-.074l.003.025a.508.508 0 00-.003-.025zm-.015-.07l.007.03a.66.66 0 00-.007-.03zm-.022-.063l.009.023a.506.506 0 00-.01-.024zm-.033-.066l.01.018a.557.557 0 00-.01-.018zM.623 1.385l.009.015a.533.533 0 01-.009-.015zm-.031-.07l.007.019a.544.544 0 01-.007-.02zm-.021-.07l.005.02a.552.552 0 01-.005-.02zM.56 1.177l.002.016a.555.555 0 01-.002-.016zm-.003-.072v0zm.006-.066l-.001.01.001-.01zm.015-.07L.576.978A.52.52 0 01.578.969zm.056-.13l.04-.06a.554.554 0 00-.05.078L.633.84zm.75-.216l.02.01.058.04a.554.554 0 00-.077-.05zm10.6 0l-.016.009a.496.496 0 01.015-.009zM.856.623L.842.632A.538.538 0 01.857.623zm11.654 0l.018.01.06.04a.547.547 0 00-.078-.05zM.925.593L.908.598A.554.554 0 01.925.592zm.39-.001L1.337.6a.553.553 0 00-.024-.01zm10.739 0l-.02.007a.608.608 0 01.02-.007zm.389 0l.02.009a.557.557 0 00-.02-.009zM.997.571l-.02.005A.566.566 0 01.998.57zm.248 0l.03.008a.557.557 0 00-.03-.008zm10.878 0l-.02.005a.58.58 0 01.02-.005zm.249 0l.027.007a.553.553 0 00-.027-.007zM1.065.56l-.016.002.016-.002zm.112 0l.027.003A.56.56 0 001.177.56zm11.014 0l-.016.002.016-.002zm.113 0l.025.003a.574.574 0 00-.025-.003zM12.23.557h.032a.56.56 0 00-.032 0zm-11.126 0h.032a.56.56 0 00-.032 0z"
      ></path>
    </svg>
  );
}

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: OrdersEmpty,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
    hideOnTransparent: true,
  },
};

const ProductCardOrder = (props) => {
  const navigate = useNavigate();

  const cardClassName = classNames("product-card-order");

  const goToDetails = () => {
    navigate(`/product/${props.product.categoryId}/${props.product.id}`);
  };

  return (
    <div className={cardClassName}>
      <div className="product-card-order__content">
        <div
          className="product-card-order__content__left adb-touchable"
          onClick={goToDetails}
        >
          <img src={props.product.image} alt={props.product.id} />
        </div>

        <div className="product-card-order__content__right">
          <CloseGrayIcon
            className="product-card-order__content__right__icon"
            onClick={() => props.removeProduct(props.product)}
          />

          <span
            className="product-card-order__content__right__title"
            onClick={goToDetails}
          >
            {props.product.title}
          </span>

          <div className="product-card-order__content__right__category">
            <span className="font-sans text-peach font-light">
              {props.product.category}
            </span>
          </div>

          <div className="product-card-order__content__right__bottom">
            <div className="product-card-order__content__right__bottom__left">
              <SubButton
                className="adb-touchable"
                onClick={() => props.subtractProduct(props)}
              />
              <b>{props.qty}</b>
              <AddButton
                className="adb-touchable"
                onClick={() => props.addProduct(props.product)}
              />
            </div>

            <span>{currency.format(props.product.price * props.qty)}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

const OrderDetails = () => {
  const focusRef = useRef();
  const sheetRef = useRef();
  const navigate = useNavigate();
  const {
    addProduct,
    subtractProduct,
    order,
    removeProductById,
    getTotalValue,
  } = useContext(CartContext);

  const removeProductOfCart = (product) => {
    removeProductById(product.id);
  };

  const goHome = () => navigate("/");

  function formatOrderForWhatsApp() {
    let message = "Olá! Gostaria de fazer o seguinte pedido:\n\n";

    order.forEach((item, index) => {
      const { qty, product } = item;
      const { title, price, category } = product;

      message += `Produto: *${title}*\n`;
      message += `Categoria: *${category}*\n`;
      message += `Quantidade: ${qty}\n`;
      message += `Preço: R$ ${price.toFixed(2)}\n`;
      message += "\n"; // Adiciona uma linha em branco entre os produtos
    });

    // Adiciona o total do pedido

    message += `Total do Pedido: *R$ ${currency.format(getTotalValue())}*`;

    // Encode o texto para usar no link do WhatsApp
    message = encodeURIComponent(message);

    // Retorna a mensagem formatada
    return message;
  }

  const finishOrder = () => {
    window.open(
      `https://wa.me/55999095880?text=${formatOrderForWhatsApp(order)}`
    );
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="order-details">
      <header className="order-details__header">
        <h1>Resumo do Pedido</h1>
        <CloseIcon onClick={goHome} />
      </header>

      <main>
        <div className="order-details__cards">
          {order && order.length > 0 ? (
            order.map((product, index) => (
              <ProductCardOrder
                {...product}
                key={index}
                addProduct={addProduct}
                subtractProduct={(order) => {
                  order.qty > 1
                    ? subtractProduct(order.product)
                    : removeProductOfCart(order.product);
                }}
                removeProduct={removeProductOfCart}
              />
            ))
          ) : (
            <div className="animate__animated animate__fadeIn">
              <Lottie options={defaultOptions} width={250} height={250} />

              <span className="text-center flex items-center mt-2">
                Ops! Parece que está faltando adicionar nossas delícias para
                poder continuar com seu pedido.
              </span>

              <button
                className="btn btn-outlined mt-2 adb-touchable"
                onClick={goHome}
              >
                Clique aqui para ver os nossos produtos
              </button>
            </div>
          )}
        </div>
      </main>

      <BottomSheet
        open
        skipInitialTransition
        ref={sheetRef}
        initialFocusRef={focusRef}
        defaultSnap={({ maxHeight }) => maxHeight / 2}
        snapPoints={({ maxHeight }) => [maxHeight, maxHeight / 2.8]}
        expandOnContentDrag
        scrollLocking={false}
        blocking={false}
      >
        <footer className="order-details__footer">
          <div className="order-details__footer__box-gray">
            <span>Frete</span>
            <span>Combinar no próximo passo</span>
          </div>

          <div className="order-details__footer__total">
            <span>Total</span>
            <b>{currency.format(getTotalValue())}</b>
          </div>

          <div className="order-details__footer__finish">
            <button
              className={classNames({
                "adb-touchable": getTotalValue() > 0,
              })}
              onClick={finishOrder}
              disabled={getTotalValue() === 0}
            >
              Finalizar Pedido
            </button>
          </div>
        </footer>
      </BottomSheet>
    </div>
  );
};

export default OrderDetails;
